import { Plugin } from 'ckeditor5/src/core';
import { ButtonView, ContextualBalloon } from 'ckeditor5/src/ui';
import { ClickObserver } from 'ckeditor5/src/engine';

import checkBoxIcon from '../../theme/icons/checkbox.svg';
import {
	CHECKBOX_ATTR_ID,
	CHECKBOX_COMMANDS,
	COMPONENT_NAME
} from '../constants';

export default class CheckBoxUI extends Plugin {
	/**
	 *
	 * @returns {string}
	 */
	static get pluginName() {
		return 'CheckBoxUI';
	}

	static get requires() {
		return [ ContextualBalloon ];
	}

	init() {
		const editor = this.editor;

		editor.editing.view.addObserver( ClickObserver );

		this._createToolbarButton();
	}

	destroy() {
		super.destroy();
	}

	_createToolbarButton() {
		const editor = this.editor;
		const t = editor.t;

		editor.ui.componentFactory.add( COMPONENT_NAME, locale => {
			const buttonView = new ButtonView( locale );
			const view = editor.editing.view;
			const viewDocument = view.document;

			buttonView.set( {
				label: t( 'Insert checkbox' ),
				icon: checkBoxIcon,
				tooltip: true,
				withText: false
			} );

			const command = editor.commands.get( CHECKBOX_COMMANDS.CREATE );
			buttonView.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' );

			this.listenTo( buttonView, 'execute', () =>
				editor.execute( CHECKBOX_COMMANDS.CREATE, {} )
			);

			editor.listenTo( viewDocument, 'click', ( event, data ) => {
				const target = data.target;
				const modelObj = editor.editing.mapper.toModelElement( target );
				if ( modelObj && modelObj.name === COMPONENT_NAME && !modelObj.hasAttribute( 'CheckboxNewValue' ) ) {
					const id = modelObj.getAttribute( CHECKBOX_ATTR_ID );
					if ( data.target.hasClass( 'dw-checkboxActive' ) ) {
						editor.execute( CHECKBOX_COMMANDS.CHANGE, { checked: false, id } );
					} else {
						editor.execute( CHECKBOX_COMMANDS.CHANGE, { checked: true, id } );
					}
				}
			} );

			return buttonView;
		} );
	}
}
